import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import UA from "../../utils/ua";

import "./style.less";
const pic = [
  'https://oss.aircourses.com/web/client/outline/261/1.jpg',
  'https://oss.aircourses.com/web/client/outline/261/2.jpg',
  'https://oss.aircourses.com/web/client/outline/261/3.jpg',
  'https://oss.aircourses.com/web/client/outline/261/4.jpg',
  'https://oss.aircourses.com/web/client/outline/261/5.jpg',
];
const hide = [
  'https://oss.aircourses.com/web/client/outline/261/week1.jpg',
  'https://oss.aircourses.com/web/client/outline/261/week2.jpg',
  'https://oss.aircourses.com/web/client/outline/261/week3.jpg',
  'https://oss.aircourses.com/web/client/outline/261/week4.jpg',
]

export default class CourseOutline3Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showIndex: []
    };
  }

  handleClick = (showIndex) => {
    const arr = [].concat(this.state.showIndex);
    const index = arr.indexOf(showIndex);
    console.log(showIndex, index)
    if(index === -1){
      arr.push(showIndex)
    }
    else{
      arr.splice(index, 1)
    }
    this.setState({
      showIndex: arr
    })
  }

  render() {
    const { showIndex } = this.state;
    return (
      <DocumentTitle title={'课程大纲'}>
        <React.Fragment>
          <div className={`courseoutline pro ${ UA.mobileClient ? '' : 'pc'}`}>
              {pic.map((ele, index) => <div className="course_box" key={index}>
                <div className='fist_wrap'>
                  <img src={ele} alt="outline" className='fist'/>
                  <div className={`icon ${showIndex.includes(index)?'active':''}`} onClick={this.handleClick.bind(this, index)}></div>
                </div>
                <img src={hide[index]} alt="outline" className={`second ${showIndex.includes(index) && 'active'}`}/>
              </div>)}
          </div>
        </React.Fragment>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/courseOutlinePage/courseOutline3Page.jsx